import { 
    gql, 
    useMutation 
} from "@apollo/client";
import { 
    ToggleLocationArchiveStatusAdminMutationMutation,
    ToggleLocationArchiveStatusAdminMutationMutationVariables 
} from "../../../../../schemaTypes";
import React, { ReactElement } from "react";

import { normalizeErrors } from "../../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../../types/NormalizedErrorMap";

export const toggleLocationArchiveStatusAdminMutation = gql`
  mutation ToggleLocationArchiveStatusAdminMutation(
        $locationId: String!
        $isArchive: Boolean!
    ) {
        toggleLocationArchiveStatusAdmin(
            locationId: $locationId
            isArchive: $isArchive
            ) {
            errors {
                path
                message
            }
            message
        }
  }
`;

interface Props {
  children: (
    data: {
      submitToggleLocationArchiveStatusAdmin: (
        values: ToggleLocationArchiveStatusAdminMutationMutationVariables
      ) => Promise<NormalizedErrorMap | any>;
      loading: boolean;
      error: any;
      message: string | null;
      toggleLocationArchiveStatusAdminData: any | null; 
    }
  ) => ReactElement | null;
}

export const ToggleLocationArchiveStatusAdminController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<
    ToggleLocationArchiveStatusAdminMutationMutation,
    ToggleLocationArchiveStatusAdminMutationMutationVariables
  >(
    toggleLocationArchiveStatusAdminMutation
  );

  const submitToggleLocationArchiveStatusAdmin = async (values: ToggleLocationArchiveStatusAdminMutationMutationVariables) => {
    const { data: {toggleLocationArchiveStatusAdmin} }:any = await mutate({ variables: values });

    if (toggleLocationArchiveStatusAdmin?.errors) {
      return {error: normalizeErrors(toggleLocationArchiveStatusAdmin.errors), toggleLocationArchiveStatusAdmin: null};
    }

    return {
      error: null,
      toggleLocationArchiveStatusAdmin
    };
  };

  const message = data?.toggleLocationArchiveStatusAdmin?.message || null;

  return children({
    submitToggleLocationArchiveStatusAdmin,
    loading,
    error,
    message,
    toggleLocationArchiveStatusAdminData: data,
  });
};